'use client';

import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '@/stores/auth-store';
import { useOrgLabels } from '@/contexts/org-labels-context';
import { createClient } from '@/lib/supabase/client';
import {
  COMPLIANCE_SURFACE_VISIBILITY_RPC_ROLES,
  loadComplianceSurfaceVisibility,
} from './server-surface-visibility';

/** Role/tenant/context form the cache identity; saves invalidate this whole family. */
export function useComplianceSurfaceVisibility() {
  const user = useAuthStore((state) => state.user);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const { programContextRevision } = useOrgLabels();
  return useQuery({
    queryKey: [
      'compliance-surface-visibility',
      user?.tenantId,
      user?.id,
      user?.role,
      programContextRevision,
    ],
    enabled:
      isAuthenticated &&
      !!user?.tenantId &&
      COMPLIANCE_SURFACE_VISIBILITY_RPC_ROLES.includes(
        user.role as (typeof COMPLIANCE_SURFACE_VISIBILITY_RPC_ROLES)[number],
      ),
    queryFn: () => loadComplianceSurfaceVisibility(createClient(), user!.tenantId!, 'user'),
    staleTime: 0,
  });
}
